import React from 'react'
import { useDeviceInfo } from 'src/hooks/useDeviceInfo'
import { InventoryButton } from '../InventoryButton'
import { InventoryPanel } from '../InventoryPanel'
import { useInventoryActions, useInventoryPanelState } from '../../store'
import { useClickOutside, useEscapeKey } from '../../hooks'
import { panelWrapperVariants } from './InventoryWidget.variants'

type InventoryWidgetProps = Readonly<{
  isActive?: boolean
  setBetAmount?: (betAmount: string) => void
  instanceId?: string
}>

export function InventoryWidget({ 
  isActive = false,
  setBetAmount,
  instanceId = 'default'
}: InventoryWidgetProps) {
  const { isMobile } = useDeviceInfo()
  const isPanelOpen = useInventoryPanelState()
  const { toggleInventoryPanel, closeInventoryPanel } = useInventoryActions()

  // Only show panel for the main instance to prevent duplicates
  const shouldShowPanel = isPanelOpen && (instanceId === 'main' || (!isMobile && instanceId === 'desktop') || (isMobile && instanceId === 'mobile'))

  // Click outside to close (desktop only)
  const containerRef = useClickOutside<HTMLDivElement>({ 
    onClickOutside: closeInventoryPanel, 
    enabled: shouldShowPanel && !isMobile 
  })

  // Close panel on Escape key
  useEscapeKey({ 
    onEscape: closeInventoryPanel, 
    enabled: shouldShowPanel 
  })

  const buttonVariant = isMobile ? 'default' : 'right'
  const panelPlacement = isMobile ? 'mobile' : 'desktop'

  return (
    <div className="relative w-full" ref={containerRef}>
      <InventoryButton
        isActive={isActive || isPanelOpen}
        onClick={toggleInventoryPanel}
        variant={buttonVariant}
      />
      {shouldShowPanel ? (
        <div className={panelWrapperVariants({ placement: panelPlacement })}>
          <InventoryPanel onClose={closeInventoryPanel} setBetAmount={setBetAmount} />
        </div>
      ) : null}
    </div>
  )
}